import { Flex, Box } from '@chakra-ui/react';
import { MagnifyingGlass } from '@phosphor-icons/react';

export const SearchBox = ({
  placeholder,
  search,
  disabled,
  bg = 'background.secondary',
  ...rest
}: React.InputHTMLAttributes<HTMLInputElement> & {
  placeholder: string;
  search: (keyword: string) => void;
  bg?: string;
}) => {
  return (
    <Flex
      alignItems="center"
      w={'400px'}
      border="1px solid"
      borderColor="neutrals.300"
      borderRadius="8px"
      bg={bg}
      p="8px"
    >
      <Box as="span" color="neutrals.500" mr="8px">
        <MagnifyingGlass size={20} />
      </Box>
      <input
        type="text"
        placeholder={placeholder}
        onChange={(event) => {
          search(event.target.value);
        }}
        onKeyDown={(event) => {
          if (event.key === 'Enter') {
            search(event.currentTarget.value);
          }
        }}
        disabled={disabled}
        style={{
          border: 'none',
          outline: 'none',
          flex: 1,
          fontSize: '16px',
          backgroundColor: 'transparent'
        }}
        {...rest}
      />
    </Flex>
  );
};
